(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1268,2941,2403],{

/***/ 2212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career/apply",
      function () {
        return __webpack_require__(2981);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3449);
/* harmony import */ var _trust_DpiitBadge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3856);






function Footer() {
    // Extra capabilities shown only in footer
    var footerOnlyCapabilities = [
        {
            name: "Agentic AI Servies & Solutions",
            link: "/services/agentic-ai"
        },
        {
            name: "AI Strategy For Business",
            link: "/outcomes"
        },
        {
            name: "Startup Solutions",
            link: "/startup"
        },
        {
            name: "Data Centre Readiness",
            link: "/services/data-center-project-readiness-governance"
        }, 
    ];
    // Combine both for footer — hub leads the Services group as the flagship practice
    var capabilitiesFooter = [
        {
            name: "Custom Software Development",
            link: "/services/custom-software-development"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_utils_data__WEBPACK_IMPORTED_MODULE_3__/* .capabilitiesNav */ .AQ), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(footerOnlyCapabilities));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
            id: "contact-us",
            className: "bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full items-center justify-between flex-wrap gap-4 md:w-[92%] mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-6 mr-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: "/logo.png",
                                            alt: "logo",
                                            height: "51",
                                            width: "30"
                                        })
                                    }),
                                    "itmtb"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_trust_DpiitBadge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            variant: "dark"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-2 md:grid-cols-5 gap-y-10 gap-x-10 my-8",
                    children: [
                        capabilitiesFooter,
                        _utils_data__WEBPACK_IMPORTED_MODULE_3__/* .industriesNav */ .xW,
                        productsNav,
                        generalPage,
                        contactLinks
                    ].map(function(navList, idx) {
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col space-y-2 items-start md:mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[20px] mb-1 font-semibold text-gray-100/40",
                                    children: ((ref = navList[0]) === null || ref === void 0 ? void 0 : ref.category) || (idx === 0 ? "Capabilities" : "")
                                }),
                                navList.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: item.link,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: item.link.includes("https:") ? "_blank" : "_self",
                                            rel: item.link.includes("https:") ? "noopener" : undefined,
                                            className: "text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white",
                                            children: item.name
                                        })
                                    }, item.link);
                                })
                            ]
                        }, idx);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-left my-10 sm:ml-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-100/40",
                            children: "Locations"
                        }),
                        "Pune | Bhopal",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-100/40",
                            children: "Email"
                        }),
                        "hello@itmtb.com"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-sm",
                    children: [
                        "Copyright \xa9 ",
                        new Date().getFullYear(),
                        " Itmtb Technologies Private Limited"
                    ]
                })
            ]
        })
    });
};
// Footer-specific lists
var contactLinks = [
    {
        name: "Contact Us",
        link: "/contact-us",
        category: "Get in Touch"
    },
    {
        name: "LinkedIn",
        link: "https://www.linkedin.com/company/itmtb/"
    },
    {
        name: "Instagram",
        link: "https://www.instagram.com/itmtbtech/"
    }, 
];
var productsNav = [
    {
        name: "Orchestrik",
        link: "https://orchestrik.ai",
        category: "Products"
    },
    {
        name: "Tomorrow Central",
        link: "/tomorrow-central",
        category: "Products"
    },
    {
        name: "Enterprise Search",
        link: "/enterprise-search",
        category: "Products"
    }, 
];
var generalPage = [
    {
        name: "About Us",
        link: "/discover-itmtb",
        category: "Others"
    },
    {
        name: "Agents at Work",
        link: "/agents-at-work"
    },
    {
        name: "Privacy Policy",
        link: "/privacy_policy.html"
    },
    {
        name: "Careers",
        link: "/career"
    }, 
]; // import Link from "next/link";
 // import Image from "next/future/image";
 // import { capabilitiesNav, industriesNav } from "../utils/data";
 // export default function Footer() {
 //   return (
 //     <section>
 //       <footer id="contact-us" className="bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10">
 //         <div className="flex w-full items-start md:w-[92%] mx-auto">
 //           <Link href="/">
 //             <div
 //               className="
 //             mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2"
 //             >
 //               <div className="w-6 mr-2">
 //                 <Image src="/logo.png" alt="logo" height="51" width="30" />
 //               </div>
 //               itmtb
 //             </div>
 //           </Link>
 //         </div>
 //         <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-10 my-8">
 //           {[capabilitiesNav, industriesNav, generalPage, contactLinks].map((navList, idx) => {
 //             return (
 //               <div key={idx} className="flex flex-col space-y-2 items-start md:mx-auto ">
 //                 <p className="text-[20px] mb-1 font-semibold text-gray-100/40">{navList[0].category}</p>
 //                 {navList.map(item => {
 //                   return (
 //                     <Link key={item.link} href={item.link}>
 //                       <a
 //                         target={item.link.includes("https:") ? "_blank" : "_self"}
 //                         className="text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white"
 //                       >
 //                         {item.name}
 //                       </a>
 //                     </Link>
 //                   );
 //                 })}
 //               </div>
 //             );
 //           })}
 //         </div>
 //         <div className="text-left my-10 sm:ml-4">
 //           <p className="text-gray-100/40">Locations</p>
 // 		  Pune | Mumbai | Bhopal
 //           <p className="text-gray-100/40">Email</p>
 // 	 hello@itmtb.com
 //         </div>
 //         <p className="text-sm">Copyright © {new Date().getFullYear()} Itmtb Technologies Private Limited</p>
 //       </footer>
 //     </section>
 //   );
 // }
 // const contactLinks = [
 //   {
 //     name: "Contact Us",
 //     link: "/contact-us",
 //     category: "Get in Touch",
 //   },
 //   {
 //     name: "LinkedIn",
 //     link: "https://www.linkedin.com/company/itmtb/",
 //   },
 //   {
 //     name: "Instagram",
 //     link: "https://www.instagram.com/itmtbtech/",
 //   },
 // ];
 // const generalPage = [
 //   {
 //     name: "About Us",
 //     link: "/discover-itmtb",
 //     category: "Others",
 //   },
 //   {
 //     name: "Privacy Policy",
 //     link: "/privacy_policy.html",
 //   },
 //   {
 //     name: "Careers",
 //     link: "/career",
 //   },
 // ];


/***/ }),

/***/ 3856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DpiitBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


// DPIIT / Startup India recognition credential — single source of truth for
// every placement (footer, about page, homepage trust strip).
//
// Uses the official DPIIT + #startupindia recognition logo supplied by the
// Startup India programme (ITMTB is a recognised startup). The logo carries the
// national emblem + wordmarks, so it sits on a white chip to stay legible on any
// surface (including the dark footer). The recognition number is the extra
// verifiable fact the logo itself does not carry.
var RECOGNITION_NO = "DIPP274362";
var LOGO_SRC = "/dpiit-startupindia.webp";
var LOGO_W = 1969;
var LOGO_H = 655;
function DpiitBadge(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "light" : _variant, _bare = param.bare, bare = _bare === void 0 ? false : _bare, _className = param.className, className = _className === void 0 ? "" : _className;
    var logoHeight = variant === "dark" ? "h-7" : "h-9";
    var chrome = bare ? "" : "rounded-lg border border-gray-200 bg-white px-4 py-2.5 shadow-sm";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "inline-flex items-center gap-3 ".concat(chrome, " ").concat(className),
        "aria-label": "Recognised by DPIIT under the Startup India initiative, recognition number ".concat(RECOGNITION_NO),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: LOGO_SRC,
                alt: "Recognised by DPIIT — Startup India",
                width: LOGO_W,
                height: LOGO_H,
                className: "".concat(logoHeight, " w-auto shrink-0")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "h-8 w-px bg-gray-200 shrink-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "leading-tight text-left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[10px] font-semibold uppercase tracking-wider text-gray-400",
                        children: "Recognised"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-sm font-semibold text-gray-900",
                        children: [
                            "Reg. No. ",
                            RECOGNITION_NO
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 2981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ApplyPage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/chevron-right.js
var chevron_right = __webpack_require__(4998);
;// CONCATENATED MODULE: ./components/career/JobAccordion.jsx



var slugify = function(title) {
    return title.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");
};
var JobAccordion = function(param) {
    var _jobs = param.jobs, jobs = _jobs === void 0 ? [] : _jobs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-3xl mx-auto p-6 space-y-4",
        children: jobs.map(function(job) {
            var slug = slugify(job.title);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/career/apply/".concat(slug),
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "block bg-white border rounded-md shadow transition-all duration-300 hover:shadow-md hover:border-orange p-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-semibold text-lg text-gray-900",
                                        children: job.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-md text-gray-600",
                                        children: [
                                            job.location,
                                            " \xa0|\xa0 ",
                                            job.type,
                                            " \xa0|\xa0 Experience: ",
                                            job.experience
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_right/* default */.Z, {
                                size: 20,
                                className: "text-orange"
                            })
                        ]
                    })
                })
            }, job.id);
        })
    });
};
/* harmony default export */ var career_JobAccordion = (JobAccordion);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/globe.js
var globe = __webpack_require__(4844);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/users.js
var users = __webpack_require__(9525);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/award.js
var award = __webpack_require__(6583);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./pages/career/apply.jsx
// pages/career/apply.jsx







var Navbar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(1352)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});


var __N_SSG = true;
function ApplyPage(param) {
    var jobs = param.jobs;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)("all"), selectedCategory = ref[0], setSelectedCategory = ref[1];
    (0,react.useEffect)(function() {
        // Apply initial category from query string
        if (router.query.category) {
            setSelectedCategory(router.query.category.toLowerCase());
        }
    }, [
        router.query.category
    ]);
    var categories = [
        "all"
    ].concat((0,_to_consumable_array/* default */.Z)(new Set(jobs.map(function(job) {
        return job.category;
    }).filter(Boolean))));
    var filteredJobs = selectedCategory === "all" ? jobs : jobs.filter(function(job) {
        return job.category === selectedCategory;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Apply | Careers at ITMTB"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Explore open roles at ITMTB and apply to become part of our innovative team."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "py-16 px-4 sm:px-6 lg:px-8 bg-white mt-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-4xl mx-auto text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-5xl font-normal text-gray-900 mb-6",
                            children: "Build the Future with Us"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xl text-gray-600 mb-8 max-w-2xl mx-auto",
                            children: "Join a team of innovators, dreamers, and builders who are reshaping industries through cutting-edge technology and human-centered design."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-wrap justify-center gap-4 text-sm text-gray-500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(globe/* default */.Z, {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Remote-First Culture"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(users/* default */.Z, {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Supportive Team Members"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(award/* default */.Z, {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Best Places to Work"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "border-orange/80 max-w-2xl mx-auto"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pt-16 pb-16 bg-gray-50 min-h-screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-5xl mx-auto px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-3xl sm:text-4xl font-normal text-center mb-10 text-black",
                            children: "Explore Opportunities at ITMTB"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-wrap justify-center gap-3 mb-6",
                            children: categories.map(function(cat) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return setSelectedCategory(cat);
                                    },
                                    className: "px-4 py-2 rounded-full border transition ".concat(selectedCategory === cat ? "bg-orange text-white border-orange" : "bg-white text-gray-700 border-gray-300 hover:border-orange"),
                                    children: cat.charAt(0).toUpperCase() + cat.slice(1)
                                }, cat);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(career_JobAccordion, {
                            jobs: filteredJobs
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
        ]
    });
};


/***/ }),

/***/ 3449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ capabilitiesNav; },
/* harmony export */   "xW": function() { return /* binding */ industriesNav; },
/* harmony export */   "zR": function() { return /* binding */ categoriesData; },
/* harmony export */   "zr": function() { return /* binding */ badgeMapper; }
/* harmony export */ });
/* unused harmony exports capabilities, careerData, careerLookingFor */
var capabilities = (/* unused pure expression or super */ null && ([
    "Cloud",
    "Cyber Security",
    "Data and Artificial Intelligence",
    "Enterprise Applications and Automation",
    "IoT and Digital Engineering",
    "Managed Services",
    "Marketing & Experience",
    "Quality Engineering",
    "Strategy",
    "Sustainability",
    "Talent & Learning",
    "Technology Consulting", 
]));
var capabilitiesNav = [
    {
        name: "Cloud",
        link: "/services/cloud",
        category: "Capabilities"
    },
    {
        name: "Cyber Security",
        link: "/services/cybersecurity"
    },
    {
        name: "AI Agents & Automation",
        link: "/services/analytics-ai-automation"
    },
    {
        name: "Forward Deployed Engineering",
        link: "/services/forward-deployed-engineering"
    },
    {
        name: "Enterprise Applications and Automation",
        link: "/services/enterprise-applications"
    },
    {
        name: "IoT and Digital Engineering",
        link: "/services/iot-and-digital-eng"
    },
    {
        name: "Managed Services",
        link: "/services/managed-services"
    },
    {
        name: "Quality Engineering",
        link: "/services/quality-engineering"
    },
    {
        name: "Strategy",
        link: "/services/strategy"
    },
    {
        name: "Technology Consulting",
        link: "/services/technology-consulting"
    },
    {
        name: "Tech Stack Audit",
        link: "/services/tech-stack-audit"
    }, 
];
var industriesNav = [
    {
        name: "Banking",
        link: "/industry/banking",
        category: "Industries"
    },
    {
        name: "Insurance",
        link: "/industry/insurance"
    },
    {
        name: "Life Sciences",
        link: "/industry/life-sciences"
    },
    {
        name: "Retail",
        link: "/industry/retail"
    },
    {
        name: "Supply Chain",
        link: "/industry/supply-chain"
    }, 
];
var badgeMapper = function(badge) {
    if (badge === "case-study") return "Success Story";
    return "Insight";
};
var careerData = [
    {
        point: "1. Solve awesome problems",
        pointText: "Whether it is technology, strategy, sales, or marketing, interesting problems find us",
        desc: "From increasing operational efficiency by 400x, to designign the most scalable cloud architecture, to rewriting algorithms to process faster in real time, all the way to discovering the right business strategies for the customer, we do it all.",
        linkText: "Success Stories",
        link: "/blog/success-stories",
        img: "/career/career - technlogies.webp"
    },
    {
        point: "2. Work across industries",
        pointText: "Our universe is truly parallel. Which one would you like?",
        desc: " Be it D2C retail, supply chain, pharma and life sciences, fintech and more, you get to expose yourself to an unparalleled diversity of business problems.",
        linkText: "",
        link: "",
        img: "/career/career - diverse industries.webp"
    },
    {
        point: "3. Have a little fun while you do it",
        pointText: "Road trips, anyone?",
        desc: "Enjoy not just the grind but also the unwinds. From unplanned road-trips to goofy ittle things, we’ve got the spirit to make every day at work ridiculously entertaining.",
        linkText: "",
        link: "",
        img: "/career/career - fun.webp"
    }, 
];
var careerLookingFor = [
    {
        title: "You must love solving problems",
        desc: "Problems excite no one. Solutions excite everyone. But only a few are willing to put their backs into finding a solution while the rest give up. You are not 'the rest.'"
    },
    {
        title: "Technology is just another toolkit in your bag",
        desc: "Can you only solve a problem if its within your skills. What do you do when needed to learn something new and deliver quickly?"
    },
    {
        title: "You must understand the value of helping your mates",
        desc: " Remember a leading runner slowing down to help his fallen competitor? Would you slow down if you knew your team mate really needed your help?"
    }, 
];
var categoriesData = [
    {
        title: "Design",
        desc: "Change is the only constant. Reinvent your business with the right strategy and technology implementations."
    },
    {
        title: "Build",
        desc: "Technology is often the key differentiator. Get the technology you need to lead the competition."
    },
    {
        title: "Improve",
        desc: "Right quality and mature operations hold the key to cost efficiency. Rediscover them."
    },
    {
        title: "Protect",
        desc: "It is important to build. It is even more imporant to protect. Safeguard your digital assets."
    }, 
]; // {
 //     "slug": "",
 //     "metaDesc": "",
 //     "metaKeyword": "",
 //     "image": "",
 //     "paragraph": "",
 //     "heading": "",
 //     "mainHeading": "",
 //     "numbers": [
 //         {
 //             "number": "",
 //             "detail": ""
 //         },
 //     ],
 //     "details": {
 //         "title": "",
 //         "summary": "",
 //         "listItems": [
 //             "",
 //         ]
 //     },
 //     "points": [
 //         {
 //             "key": "",
 //             "title": "",
 //             "text": ""
 //         },
 //     ],
 //     "whyChooseUs": ""
 // }


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,7137,9774,2888,179], function() { return __webpack_exec__(2212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);